/* eslint-disable no-throw-literal */
import {
  GET_EVALUATE_QUESTION_ALL,
  GET_EVALUATE_QUESTION_LIST,
  EVALUATE_QUESTION_DELETE,
  EVALUATE_QUESTION_CREATE,
  GET_EVALUATE_QUESTION_DETAIL,
  EVALUATE_QUESTION_UPDATE,
  CSV_EVALUATE_QUESTION_ANSWER
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_EVALUATE_QUESTION_ALL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/evaluate/evaluate_questions/all_get', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CSV_EVALUATE_QUESTION_ANSWER] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/evaluate/answers/csv_download', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    [GET_EVALUATE_QUESTION_LIST] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/evaluate/evaluate_questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [EVALUATE_QUESTION_DELETE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiDelete', {url: `/master/evaluate/evaluate_questions/${params.data.id}`})
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [EVALUATE_QUESTION_CREATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/master/evaluate/evaluate_questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [GET_EVALUATE_QUESTION_DETAIL] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/evaluate/evaluate_questions/${params.id}/edit` })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [EVALUATE_QUESTION_UPDATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/evaluate/evaluate_questions/${params.id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/evaluate-question.js